import apiService from "./apiService";

const TransportistasService = {
  getLineasTransporte: () => apiService.get(`/api/v1/lineas_transporte/`),
  getLineaTransporteConductores: (linea_transporte_id) => apiService.get(`/api/v1/lineas_transporte/${linea_transporte_id}/conductores`),
  getLineaTransporteVehiculos: (linea_transporte_id) => apiService.get(`/api/v1/lineas_transporte/${linea_transporte_id}/vehiculos`),
  getRequerimientos: () => apiService.get(`/api/v1/requerimientos`),
  postResetPasswordOperador: (operadorData) => apiService.post("/api/v1/reset_password/operador", operadorData),

  postMonitoringTrackingDetail: (MonitoringData) => apiService.post("/api/v1/monitoring_tracking_detail", MonitoringData),

  getOperadores: () => apiService.get(`/api/v1/operadores`),
  

  getCuentas: () => apiService.get(`/api/v1/cuentas`),
  getBodegas: () => apiService.get(`/api/v1/bodegas`),
  
  //   getUserById: (id) => apiService.get(`/users/${id}`),
//   createUser: (userData) => apiService.post("/users", userData),
//   updateUser: (id, userData) => apiService.put(`/users/${id}`, userData),
//   deleteUser: (id) => apiService.delete(`/users/${id}`),
};

export default TransportistasService;
